import React from 'react'
import Link from 'components/Link'

import { routes } from 'constants/routes'

export const UPGRADE_PERSONAL_WORKSPACE_BANNER_ID = 'upgrade-personal-workspace'

interface WorkspaceIdBannerProps {
  workspaceId: string
  isUserAdmin?: boolean
}

export const CanceledBanner: React.FC<WorkspaceIdBannerProps> = ({
  workspaceId,
  isUserAdmin,
}) => {
  const banner = isUserAdmin ? (
    <>
      Your workspace subscription has been canceled and{' '}
      <b>documents are now in read-only mode</b>. Please reactivate your
      subscription in{' '}
      <Link
        to={routes.WORKSPACE_SETTINGS_BILLING.create({
          workspaceId,
        })}>
        Workspace Settings
      </Link>
      .
    </>
  ) : (
    <>
      Your workspace subscription has been canceled and{' '}
      <b>documents are now in read-only mode</b>. Admins can reactivate your
      subscription.
    </>
  )

  return banner
}

export const UnpaidCancelBanner: React.FC<WorkspaceIdBannerProps> = ({
  workspaceId,
}) => (
  <>
    We canceled your workspace due to an issue with your payment method. Please
    update your payment details in your{' '}
    <Link
      to={routes.WORKSPACE_SETTINGS_BILLING.create({
        workspaceId,
      })}>
      subscription settings
    </Link>
    .
  </>
)

export const IncompleteBanner: React.FC<WorkspaceIdBannerProps> = ({
  workspaceId,
}) => (
  <>
    We were unable to validate your card. Please review your payment details in
    your{' '}
    <Link
      to={routes.WORKSPACE_SETTINGS_BILLING.create({
        workspaceId,
      })}>
      subscription settings
    </Link>
    .
  </>
)

export const PastDueBanner: React.FC<WorkspaceIdBannerProps> = ({
  workspaceId,
}) => (
  <>
    Your payment is due. Please check your{' '}
    <Link
      to={routes.WORKSPACE_SETTINGS_BILLING.create({
        workspaceId,
      })}>
      billing details
    </Link>{' '}
    or contact Customer Support.
  </>
)

export const PersonalWorkspaceBanner = ({
  workspaceId,
}: {
  workspaceId: string
}) => (
  <>
    Make the most of Sketch by{' '}
    <Link
      to={routes.WORKSPACE_SETTINGS_GENERAL.create({
        workspaceId,
      })}>
      upgrading
    </Link>{' '}
    your Personal Workspace.
  </>
)
